<template>
  <div>
    <div class="inforcontainer" v-bind:key="user.id" v-for="user in userData">
      <div id="guestLoginContainer" class="guestLoginContainer">
        <form id="memberform" @submit.prevent="">
          <label for="firstName">Username</label><br />
          <input
            type="name"
            name="username"
            id="username"
            autocomplete="on"
          /><br />

          <label for="firstName">Password</label><br />
          <input
            type="name"
            name="password"
            id="password"
            autocomplete="on"
          /><br />

          <input
            v-on:click="checkMember"
            type="submit"
            value="Submit"
            name="loginSubmitMember"
            id="loginsubmitMember"
          />

          <button class="memberLogin" v-on:click="guestLogin">
            Guest Login
          </button>
        </form>

        <form id="userform" @submit.prevent="checkForm">
          <h4>Get your estimate!</h4>
          <br />
          <label for="firstName">First Name</label><br />
          <input
            type="name"
            name="firstName"
            id="firstName"
            v-model="user.firstName"
            autocomplete="on"
          /><br />

          <label for="lastName">Last Name</label><br />
          <input
            type="name"
            name="lastName"
            id="lastName"
            v-model="user.lastName"
            autocomplete="on"
          /><br />

          <label for="email">Email</label><br />
          <input
            type="email"
            name="email"
            id="emailAddress"
            v-model="user.emailAddress"
            autocomplete="on"
          /><br />

          <label for="phoneNumber">Phone Number</label><br />
          <input
            type="tel"
            name="phoneNumber"
            id="phoneNumber"
            v-model="user.phoneNumber"
            autocomplete="on"
          /><br />

          <input
            type="submit"
            value="Submit"
            name="loginsubmit"
            id="loginsubmit"
            autocomplete="on"
          /><br />

          <!-- <button class="memberLogin" v-on:click="memberLogin">
            Member Login
          </button> -->
        </form>
      </div>
    </div>
  </div>
</template>
<script src="https://code.jquery.com/jquery-3.4.1.js"></script>

<script>
export default {
  name: "guestLogin",
  props: ["userData"],
  methods: {
    checkForm() {
      var formInvalid = false;
      $("#userform input").each(function () {
        if ($(this).val() === "") {
          formInvalid = true;
        }
      });
      if (formInvalid);
      else {
        // alert('Please fill in all form fields')
        var self = this;
        setTimeout(function () {
          self.$emit("disable-form");
          $(".floating-panel").toggleClass("formadd");
        }, 200);
      }
    },
    checkMember() {
      var memberFrormInvalid = true;
      if (
        $("#memberform #username").val() === "" ||
        $("#memberform #password").val() === ""
      ) {
        memberFrormInvalid = false;
      }
      if (memberFrormInvalid) alert("Wrong Username or Password");
      else {
        $("#guestLoginContainer").css("left", "-360px");
        this.$emit("adminid");
        $(".memberLogin").css("display", "none");
      }
    },
    memberLogin() {
      $("#guestLoginContainer").css("left", "0px");
    },
    guestLogin() {
      $("#guestLoginContainer").css("left", "-360px");
    },
  },
};
</script>

<style>
h4 {
  font-family: sofia-pro, sans-serif;
  font-size: 16px !important;
  color: #707070;
}

input {
  width: 300px;
  background-color: #e5e5e5;
  border: none;
  padding: 10px !important;
  border-radius: 5px;
  font-size: 16px !important;
}

.guestLoginContainer > div > input {
  margin: 5px 0px !important;
}

.guestLoginContainer > div:nth-child(1) {
  margin-bottom: 0px !important;
}

.guestLoginContainerLabel {
  padding-top: 10px !important;
}

.guestLoginContainer {
  height: auto;
  width: 1000px;
  left: -360px;
  position: relative;
  opacity: 1;
  float: left;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

.inforcontainer {
  float: left;
}

.inforcontainer {
  width: auto;
  left: 0px;
  position: relative;
  -webkit-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

#memberform,
#userform {
  float: left;
}

#userform {
  margin-left: 40px !important;
}

.memberLogin {
  background: none;
  color: #297bce;
  font-size: 10px !important;
}

.memberLogin:hover {
  background: none !important;
}
</style>
